import DashboardFilters from "../../../_dashboard-filters";
import { mapState } from "vuex";
import { AlertTypes } from "../../../../constants/alert_types";
import i18n from "../../../../plugins/i18n";

export default {
  name: "AlertsFilter",
  props: { setMainFilter: Function, selectedFilter: Object },
  components: { DashboardFilters },

  data() {
    return {
      // Filters
      options: [
        {
          filter: AlertTypes.Heat,
          name: i18n.t(`cowGenerics.cowLogs.${AlertTypes.Heat}`),
          icon: "chart/heat"
        },
        {
          filter: AlertTypes.RepeatHeat,
          name: i18n.t(`cowGenerics.cowLogs.${AlertTypes.RepeatHeat}`),
          icon: "chart/heat"
        },
        {
          filter: AlertTypes.HighTemp,
          name: i18n.t(`cowGenerics.cowLogs.${AlertTypes.HighTemp}`),
          icon: "chart/fever"
        },
        {
          filter: AlertTypes.LowTemp,
          name: i18n.t(`cowGenerics.cowLogs.${AlertTypes.LowTemp}`),
          icon: "chart/low_temp"
        },
        // {
        //   filter: AlertTypes.PossibleMilkFever,
        //   name: i18n.t(`cowGenerics.cowLogs.${AlertTypes.PossibleMilkFever}`),
        //   icon: "chart/fever"
        // },
        {
          filter: AlertTypes.LowWaterIntake,
          name: i18n.t(`cowGenerics.cowLogs.${AlertTypes.LowWaterIntake}`),
          icon: "chart/few_water_intake"
        },
        {
          filter: AlertTypes.IncreasedActivity,
          name: i18n.t(`cowGenerics.cowLogs.${AlertTypes.IncreasedActivity}`),
          icon: "chart/increased_activity"
        },
        {
          filter: AlertTypes.DecreasedActivity,
          name: i18n.t(`cowGenerics.cowLogs.${AlertTypes.DecreasedActivity}`),
          icon: "chart/decreased_activity"
        },
        {
          filter: AlertTypes.Calving,
          name: i18n.t(`cowGenerics.cowLogs.${AlertTypes.Calving}(Alert)`),
          icon: "chart/calving"
        }
      ]
    };
  },
  computed: {
    ...mapState({
      summary: state => {
        return state.alerts.totals;
      }
    })
  }
};



// WEBPACK FOOTER //
// ./src/components/_dashboard/alerts/filter/alerts-filter.js